import AddMaketingExecutive from "../../features/marketingManager/AddMaketingExecutive"


const AddMarketingExecutivePage = () => {
  return <AddMaketingExecutive/>
}

export default AddMarketingExecutivePage